module.exports = __webpack_public_path__ + "static/img/XTBG.9743ccec.png";